module.exports = __webpack_public_path__ + "static/media/magazine.61f2ceff.png";